import clsx from 'clsx';
import { LoadingButton } from 'library/buttons';
import { LoadingButtonProps } from 'library/buttons/components/LoadingButton';
import { FC } from 'react';

interface ActionButtonProps extends LoadingButtonProps {}

const ActionButton: FC<ActionButtonProps> = (props) => {
    const { type = 'submit', isLoading = false, loadingText, children, className, ...rest } = props;

    return (
        <LoadingButton
            {...rest}
            type={type}
            size="lg"
            className={clsx('w-full h-[58px]', className)}
            isLoading={isLoading}
            loadingText={loadingText}
        >
            {children}
        </LoadingButton>
    );
};

export default ActionButton;
